import LoggerFactory from '../../Util/Logger/LoggerFactory';
import createUniqueId from '../../Util/id';

class SimpleChannel {
  private readonly eventName: string;

  private logger = LoggerFactory.get('SimpleChannel.ts');

  constructor(eventPrefix?: string) {
    this.eventName = createUniqueId(eventPrefix ? `${eventPrefix}-` : 'event-');
  }

  public subscribe(handler: () => void): { stop: () => void } {
    const sub = {
      stop: (): void => window.removeEventListener(this.eventName, handler)
    };
    window.addEventListener(this.eventName, handler);
    return sub;
  }

  public broadcast(): void {
    this.logger.log(`SimpleChannel "${this.eventName}" broadcasted.`);
    window.dispatchEvent(new CustomEvent(this.eventName));
  }
}

export default SimpleChannel;
